import {PossessedSymbol} from "../reels/PossessedSymbol";
import {PossessedStatics} from "../config/PossessedStatics";
import {Possessed} from "../Possessed";

// Just a container for symbols that takes care of positioning added symbols to follow the reel shape
export class PossessedSymbolsView extends PIXI.Container
{
    private sideContainer:PIXI.Container;
    private middleContainer:PIXI.Container;

    constructor(maskSideReels:boolean = false, maskMiddleReels:boolean = false) {
        super();
        this.position.y = 152;

        this.sideContainer = new PIXI.Container();
        this.sideContainer.name = "Side Reels";
        this.sideContainer.position.y = PossessedStatics.SYMBOL_HEIGHT*2;
        if(maskSideReels) {
            const sideMask = new PIXI.Graphics();
            sideMask.name = "Mask";
            sideMask.beginFill();
            sideMask.drawRect(0, -PossessedStatics.SYMBOL_HEIGHT/2, PossessedStatics.SYMBOL_WIDTH * PossessedStatics.NUMBER_OF_REELS, PossessedStatics.SYMBOL_HEIGHT * PossessedStatics.NUMBER_OF_ROWS[0]);
            sideMask.endFill();
            this.sideContainer.mask = sideMask;
            this.sideContainer.addChild(sideMask);
        }
        this.addChild(this.sideContainer);

        this.middleContainer = new PIXI.Container();
        this.middleContainer.name = "Middle Reels";
        if(maskMiddleReels) {
            const middleMask = new PIXI.Graphics();
            middleMask.beginFill();
            middleMask.drawRect(PossessedStatics.SYMBOL_WIDTH, -PossessedStatics.SYMBOL_HEIGHT/2, PossessedStatics.SYMBOL_WIDTH*3, PossessedStatics.SYMBOL_HEIGHT*PossessedStatics.NUMBER_OF_ROWS[2]);
            middleMask.endFill();
            middleMask.name = "Mask";
            this.middleContainer.mask = middleMask;
            this.middleContainer.addChild(middleMask);
        }
        this.addChild(this.middleContainer);
    }

    addSymbol(sym:PossessedSymbol) {
        if(sym.reelID == 0 || sym.reelID == 4) {
            this.sideContainer.addChild(sym);
        } else {
            this.middleContainer.addChild(sym);
        }
    }

    removeSymbol(sym:PossessedSymbol) {
        if(sym.reelID == 0 || sym.reelID == 4) {
            this.sideContainer.removeChild(sym);
        } else {
            this.middleContainer.removeChild(sym);
        }
    }
}